export default __webpack_public_path__ + "static/media/More.8f571508.svg";